import React, { useState } from "react";
import { Outlet, NavLink } from "react-router-dom";
import { signOut } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../../firebase.init";
import { useAdminRole } from "../../hooks/useAdminRole";

const allNavItems = [
  { to: "/admin", label: "Dashboard", icon: "fa-chart-line", end: true },
  { to: "/admin/public-donors", label: "Public Donors", icon: "fa-users" },
  { to: "/admin/registered-donors", label: "Registered Donors", icon: "fa-user-check", superAdminOnly: true },
  { to: "/admin/blood-requests", label: "Blood Requests", icon: "fa-hand-holding-droplet" },
  { to: "/admin/audit-logs", label: "Audit Logs", icon: "fa-clock-rotate-left", superAdminOnly: true },
  { to: "/admin/analytics", label: "API Requests", icon: "fa-chart-pie", superAdminOnly: true },
  { to: "/admin/donor-query", label: "Donor Query", icon: "fa-magnifying-glass", superAdminOnly: true },
  { to: "/admin/demand-analytics", label: "Demand Analytics", icon: "fa-chart-area", superAdminOnly: true },
  { to: "/admin/settings", label: "Settings", icon: "fa-gear", superAdminOnly: true },
];

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [user] = useAuthState(auth);
  const { isSuperAdmin, role } = useAdminRole();

  const navItems = allNavItems.filter(
    (item) => !item.superAdminOnly || isSuperAdmin
  );

  return (
    <div className="drawer drawer-mobile">
      <input
        type="checkbox"
        className="drawer-toggle"
        checked={sidebarOpen}
        onChange={() => setSidebarOpen(!sidebarOpen)}
      />

      {/* Main content */}
      <div className="drawer-content flex flex-col">
        {/* Top bar */}
        <div className="navbar bg-white shadow-sm border-b">
          <div className="flex-none lg:hidden">
            <label
              className="btn btn-square btn-ghost"
              onClick={() => setSidebarOpen(true)}
            >
              <i className="fa-solid fa-bars text-gray-700"></i>
            </label>
          </div>
          <div className="flex-1">
            <span className="text-xl font-bold text-red-600">Admin Panel</span>
            {role && (
              <span className="ml-2 text-xs font-semibold px-2 py-1 rounded-full bg-red-100 text-red-700">
                {role === "super_admin" ? "Super Admin" : "Admin"}
              </span>
            )}
          </div>
          <div className="flex-none gap-2">
            <span className="text-sm text-gray-700 hidden sm:block">{user?.email}</span>
            <button
              className="btn btn-sm btn-error text-white"
              onClick={() => signOut(auth)}
            >
              Logout
            </button>
          </div>
        </div>

        {/* Page content */}
        <div className="flex-1 p-4 bg-base-200">
          <Outlet />
        </div>
      </div>

      {/* Sidebar */}
      <div className="drawer-side">
        <label
          className="drawer-overlay"
          onClick={() => setSidebarOpen(false)}
        ></label>
        <ul className="menu p-4 w-64 bg-white text-gray-800">
          <li className="mb-4">
            <span className="text-lg font-bold text-red-600">
              <i className="fa-solid fa-droplet"></i> Blood Donation Admin
            </span>
          </li>
          {navItems.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `flex items-center gap-2 ${isActive ? "active bg-red-50 text-red-600" : "text-gray-700"}`
                }
                onClick={() => setSidebarOpen(false)}
              >
                <i className={`fa-solid ${item.icon}`}></i>
                {item.label}
              </NavLink>
            </li>
          ))}
          <li className="mt-auto border-t pt-2">
            <NavLink
              to="/profile"
              className="flex items-center gap-2 text-gray-700"
              onClick={() => setSidebarOpen(false)}
            >
              <i className="fa-solid fa-user"></i>
              Profile
            </NavLink>
          </li>
          <li>
            <button
              className="flex items-center gap-2 text-gray-700 w-full text-left"
              onClick={() => signOut(auth)}
            >
              <i className="fa-solid fa-right-from-bracket"></i>
              Logout
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AdminLayout;
